import type {FilterProvider} from '@github-ui/filter'
import type {NestedFilterProvider} from '@github-ui/filter/providers'
import {getDefaultReposProviders} from '@github-ui/repos-filter/providers'

import type {ItemConfig, ItemLiterals} from '../base-types'
import {ListItemRepoIcon} from '../components/ListItemRepoIcon'
import {reposPickerRepositoriesPath} from '../paths'
import type {PickerRepository, PickerScope} from '../types'
import {useQueryDefinitions} from './use-query-definitions'

export const itemLiterals: ItemLiterals = {
  itemName: 'repository',
  itemsName: 'repositories',
  listTitle: 'Repositories list',
}

type Provider = FilterProvider | NestedFilterProvider

interface Options {
  scope: PickerScope
  providers?: Provider[]
}

export function useReposItemConfig({scope, providers}: Options): ItemConfig<PickerRepository> {
  const {data: definitions} = useQueryDefinitions({scope, enabled: !providers})

  return {
    ...itemLiterals,
    getSearchUrl: query => reposPickerRepositoriesPath({scope, query}),
    onRenderItemLeadingVisual: repo => <ListItemRepoIcon visibility={repo.visibility} />,
    onRenderItemName: repo => getRepoName(repo, scope.type),
    providers: providers || getDefaultReposProviders(definitions || []),
  }
}

export function getRepoName(repo: PickerRepository, scopeType: PickerScope['type']) {
  const showRepoOwner = scopeType !== 'organization' && scopeType !== 'user'
  if (showRepoOwner && repo.ownerLogin) {
    return `${repo.ownerLogin}/${repo.name}`
  }
  return repo.name
}
